/** @jsx jsx */
import { jsx } from '@emotion/core'
import { DocType, DocumentView } from './DocumentView'

const MarketingConsents = () => {
    return <DocumentView type={DocType.marketingConsents} />
}

export { MarketingConsents }
